"use strict";

exports.__esModule = true;
exports["default"] = Replay;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Replay(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M458.7 242.4c-7.6 0-13.8 6.2-13.8 13.8-.1 104.3-84.8 189.2-189 189.2-50.5 0-97.9-19.7-133.5-55.4-35.6-35.7-55.3-83.2-55.2-133.8C67.2 151.8 152 67 256.1 67c50.4 0 98.3 20.3 133.6 55.8l-88.8-.3c-7.9 0-14.2 6.4-14.2 14.2-.1 3.9 1.5 7.5 4.1 10.1 2.6 2.6 6.1 4.1 10.1 4.1l122.1.1c1.8-.1 3.6-.4 5.4-1.1 1.8-.7 3.3-1.8 4.7-3.1 1.3-1.4 2.4-2.9 3-4.6.8-1.7 1.1-3.6 1.1-5.4L437 15.2C437 7.3 430.7 1 422.9 1s-14.1 6.3-14.2 14.2v87.6c-40.4-40.4-95-63.4-152.6-63.5-119.4 0-216.5 97.3-216.6 216.8 0 57.9 22.4 112.4 63.3 153.3 40.9 41 95.2 63.5 153.1 63.5 119.4 0 216.5-97.3 216.6-216.8 0-7.5-6.2-13.7-13.8-13.7z"
  }));
}